import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'Allgemein',
    [Tab.SignedLive]: 'Unterzeichnet / Live',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Kommission',
  },
};
